import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadConfigs (options) {
    const params = {
      limit: 20,
      offset: 0,
      is_archived: false,
      ordering: '-id',
      search: options?.search || null
    }

    return new Promise((resolve, reject) => {
      axiosInstance.get('/stc/configs/', { params }).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadConfig (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/stc/configs/${id}/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async createConfig (name, configJson) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/stc/configs/', { name, config_json: configJson }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateConfig (id, configJson) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/stc/configs/${id}/`, { config_json: configJson }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
